import React from "react";
import "./style.scss";
import { Carousel } from "antd";
import partner1 from "../../assets/images/logo1.png";
import partner2 from "../../assets/images/newcastle.png";
import partner3 from "../../assets/images/royal-acadmy.png";
import partner4 from "../../assets/images/smart-lab.png";
import partner5 from '../../assets/images/GJU_logo.svg.png';

import slide1 from "../../assets/images/slide1.jpeg";
import slide2 from "../../assets/images/slide2.jpeg";
import slide3 from "../../assets/images/slide3.jpeg";
import slide4 from "../../assets/images/slide4.jpeg";

import howToTrade from '../../assets/images/how-to-trade.png';

const Landing = (props) => {
  return (
    <div className="row">
      <div className="col-12">
        <Carousel autoplay >
          <div>
            <img src={slide1} className="slide-img" alt="slide1" />
          </div>
  
          <div>
            <img src={slide2} className="slide-img" alt="slide2" />
          </div>
          <div>
            <img src={slide3} className="slide-img" alt="slide3" />
          </div>
          <div>
            <img src={slide4} className="slide-img" alt="slide4" />
          </div>
        </Carousel>
      </div>
      <div className="col-12 row p-4 trading">
        <div className="col-6 text-center">
          {/* <h3 className="slide-img">4</h3> */}
          <img src={howToTrade} className="mx-auto" alt="how-to-trade" />
        </div>
        <div className="col-6">
          <h4>How to Trade?</h4>
          <p>
            This platform enables subscribers to share their surplus electricity
            within the microgrids in Jordanian network. The consumers have to
            submit their energy requests in kWh. After that prosumer will give
            there offers to each request with requested energy and their total
            price. Once the offer is approved by the aggregator, the consumer
            can select on of the nominated offers. The aggregator will accept
            only offers with certain losses range, for example (400W in single
            phase, and 2500 W in 3-phase).
          </p>
        </div>
      </div>

      <div className="col-12 row p-4 gray-section">
        <div className="col-6">
          {/* <h3 className="slide-img">4</h3> */}
          <img src={partner3} alt="funding agency" />
        </div>
        <div className="col-6">
          <h4>Funding Agency</h4>
          <p>
            This research was funded by [Royal Academy of Engineering], grant
            number [IAPP18/19-163, 2019].
          </p>
          <p>
            The Royal Academy of Engineering is committed to supporting
            technical leadership for a larger society as well as leadership in
            engineering and technology. In the UK and abroad, it offers
            impartial professional advice to the government as well as
            innovative leadership in engineering and technology. Additionally,
            this organization is concerned about supporting talent and acquiring
            future-ready skills, encouraging innovation, forming international
            partnerships, influencing public policy, and interacting with the
            general public.
          </p>
          <p>
            <a href="https://raeng.org.uk/" rel="noreferrer" target={"_blank"}>
              https://raeng.org.uk/
            </a>
            &nbsp;The project title: Innovative Peer to Peer Electricity Sharing
            Towards the Development of Smart and Cooperative Microgrid.
          </p>
        </div>
      </div>

      <div className="col-12 row p-4 partners-section">
        <h4>Partners</h4>
        <div className="partners">
          <img src={partner1} alt="partner" />
          <img src={partner2} alt="partner" style={{height:"65px"}} />
          <img src={partner3} alt="partner" style={{height:"80px"}} />
          <img src={partner5} alt="partner" style={{height:"75px"}} />
          <img src={partner4} alt="partner" />
        </div>
      </div>
    </div>
  );
};

export default Landing;
